export function getFileExtension(s: string): string {
    return s.substring(s.lastIndexOf(".") + 1).toLowerCase();
}
